import { ShimmerSkeleton } from '@/components/effects/ShimmerSkeleton';
import { motion } from 'framer-motion';

export const PageLoader = () => {
  return (
    <motion.div 
      className="min-h-[60vh] w-full py-8 space-y-6"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.3 }}
    >
      {/* Header skeleton */}
      <div className="space-y-4">
        <ShimmerSkeleton variant="text" lines={1} className="max-w-md" />
        <ShimmerSkeleton variant="text" lines={1} className="max-w-xs" />
      </div>
      
      {/* Cards grid skeleton */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <ShimmerSkeleton variant="card" showImage lines={2} />
        <ShimmerSkeleton variant="card" showImage lines={2} />
        <ShimmerSkeleton variant="card" showImage lines={2} />
      </div>
      
      {/* Content skeleton */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <ShimmerSkeleton variant="list" lines={4} showAvatar />
        <ShimmerSkeleton variant="card" lines={5} />
      </div>
    </motion.div>
  );
};
